import { render, staticRenderFns } from "./RankingComponent.vue?vue&type=template&id=0bf25b2f&scoped=true&"
import script from "./RankingComponent.vue?vue&type=script&lang=js&"
export * from "./RankingComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bf25b2f",
  null
  
)

export default component.exports